import React from 'react';
/* eslint-disable max-len */

const LineHeightTwo = (): JSX.Element => (
  <svg width="30px" height="30px" viewBox="0 0 30 30">
    <defs>
      <path d="M6,23 L24,23 L24,21 L6,21 L6,23 L6,23 Z M6,16 L24,16 L24,14 L6,14 L6,16 L6,16 Z M6,9 L24,9 L24,7 L6,7 L6,9 L6,9 Z" id="lineHeight2-id" />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <mask id="lineHeight2-mask" fill="white">
        <use xlinkHref="#lineHeight2-id" />
      </mask>
      <g mask="url(#lineHeight2-mask)" fill="#FFFFFF">
        <g transform="translate(2.000000, 2.000000)" id="White">
          <rect x="0" y="0" width="26" height="26"/>
        </g>
      </g>
    </g>
  </svg>
);

export default LineHeightTwo;
